import React, { createContext, useReducer } from "react";
import StatsReducer from "../reducers/stats.reducer";
import moment from 'moment';
import { filters } from "../../statics/stats";

const initialState: any = {
  filters,
  activeFilter: 'currentWeek',
  activeRange: {
    from: moment().startOf('isoWeek').format('YYYY-MM-DD'),
    to: moment().endOf('isoWeek').format('YYYY-MM-DD')
  },
  chartLabels: [],
  workingHours: [],
  tasks: [],
  activities: {
    labels: [],
    colors: [],
    data: []
  },
  employees: []
};

export const StatsContext = createContext(initialState);
export const StatsProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(StatsReducer, initialState);

  function setChartFilter(activeFilter: string) {
    dispatch({
      type: "SET_CHARTS_FILTER",
      payload: { activeFilter }
    });
  }

  function setWorkingHours(workingHours: any) {
    dispatch({
      type: "SET_WORKING_HOURS",
      payload: { workingHours }
    });
  }

  function setTasks(tasks: any) {
    dispatch({
      type: "SET_TASKS",
      payload: { tasks }
    });
  }

  function setActivities(activities: any) {
    dispatch({
      type: "SET_ACTIVITIES",
      payload: { activities }
    });
  }

  function setEmployees(employees: any) {
    dispatch({
      type: "SET_EMPLOYEES",
      payload: { employees }
    });
  }

  function setChartLabels(labels: any) {
    dispatch({
      type: "SET_CHARTS_LABELS",
      payload: { labels }
    });
  }
  const { filters, activeFilter, activeRange, workingHours, tasks, activities, employees, chartLabels } = state;
  return (
    <StatsContext.Provider
      value={{
        setChartFilter,
        setWorkingHours,
        setTasks,
        setActivities,
        setEmployees,
        setChartLabels,
        filters,
        activeFilter,
        activeRange,
        chartLabels,
        workingHours,
        tasks,
        activities,
        employees
      }}
    >
      { children }
    </StatsContext.Provider>
  );
};